module.exports = __webpack_public_path__ + "static/img/tarif-pasti.67c887f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/tarif-pasti.png
// module id = REcJ
// module chunks = 1